export const normalizeTokenPayload = (payload) => {
  if (!payload || typeof payload !== "object") {
    return {};
  }

  return {
    ...payload,
    accessToken: payload.accessToken || payload.access_token || null,
    refreshToken: payload.refreshToken || payload.refresh_token || null,
    expiresIn: payload.expiresIn ?? payload.expiry ?? payload.expires_in ?? null,
    refreshTokenExpiresIn:
      payload.refreshTokenExpiresIn ??
      payload.refresh_expiry ??
      payload.refreshTokenExpiry ??
      null,
    userType: payload.userType || payload.user_type || null,
  };
};
